import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 28,
  medium: 18,
  small: 13,
  xSmall: 11
};
const InternalLinkIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.3536 13.1213L8.17157 16.3033C6.60948 17.8654 6.60948 20.3981 8.17157 21.9602C9.68633 23.4749 12.1137 23.5208 13.6838 22.0979L13.8284 21.9602L17.0104 18.7782L17.7175 19.4853L14.5355 22.6673C12.5829 24.6199 9.41709 24.6199 7.46447 22.6673C5.56323 20.766 5.5132 17.7146 7.31437 15.7528L7.46447 15.5962L10.6464 12.4142L11.3536 13.1213ZM18.7782 12.0607L12.4142 18.4246L11.7071 17.7175L18.0711 11.3536L18.7782 12.0607ZM22.6673 7.46447C24.5607 9.35792 24.6181 12.3922 22.8394 14.3547L22.6673 14.5355L19.4853 17.7175L18.7782 17.0104L21.9602 13.8284L22.0979 13.6838C23.5208 12.1137 23.4749 9.68633 21.9602 8.17157C20.4501 6.66155 18.0332 6.61121 16.4627 8.02057L16.3033 8.17157L13.1213 11.3536L12.4142 10.6464L15.5962 7.46447L15.7528 7.31437C17.7146 5.5132 20.766 5.56323 22.6673 7.46447Z",
        fill: "currentColor"
      }
    )
  );
};
InternalLinkIcon.iconName = "InternalLinkIcon";

export { InternalLinkIcon };
